goog.provide("shadow.js.shim.module$date_fns$locale$ar_SA$default");
shadow.js.shim.module$date_fns$locale$ar_SA$default = esm_import$date_fns$locale$ar_SA.default;
